<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6">
        <SelectCustomerComponent v-on:customer-is-selected="rerenderLinkComponent"></SelectCustomerComponent>
        <ShowCustomerComponent v-if="hasCustomer"></ShowCustomerComponent>
        <ShowAvailablePoliciesComponent v-if="hasCustomer"></ShowAvailablePoliciesComponent>
        <LinkAFDPackageMessagesToPoliciesComponent
            v-if="hasCustomer"
            :key="linkKey"
            :grouped-policy-messages="groupedPolicyMessages"
            :package-message="packageMessage"></LinkAFDPackageMessagesToPoliciesComponent>


      </div>
      <div class="col-md-6">
        <div class="panel panel-stretch panel-primary">
          <div class="panel-heading">
            Gedetaileerde berichtinformatie
          </div>
          <div class="panel-body">
            <a-collapse :default-active-key="String(packageMessage.id)">
              <a-collapse-panel :key="String(packageMessage.id)" :header="'Pakket ' + packageMessage.package_number"
                                :forceRender=true style="overflow:visible" class="show-overflow">
                <sivi-message :afd-message-id="String(packageMessage.id)" :attachments-savable="true" :save-attachments-open="true"
                              style="padding-top: 10px"/>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>

        <div v-for="(messageGroup, key) in groupedPolicyMessages">
          <div class="panel panel-stretch panel-primary">
            <div class="panel-heading">
              Polis {{ key }}
            </div>
            <div class="panel-body">
              <a-collapse>
                <a-collapse-panel v-for="policyMessage in messageGroup" :key="policyMessage.id"
                                  :header="'Bericht ' + policyMessage.message_id" class="show-overflow">
                  <sivi-message :afd-message-id="String(policyMessage.id)" :attachments-savable="true"
                                style="padding-top: 10px"
                  ></sivi-message>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SiviMessageComponent from "./SiviMessageComponent";
import LinkAFDPackageMessagesToPoliciesComponent from "./LinkAFDPackageMessagesToPoliciesComponent";
import SelectCustomerComponent from "./SelectCustomerComponent";
import ShowAvailablePoliciesComponent from "./ShowAvailablePoliciesComponent";
import ShowCustomerComponent from "./ShowCustomerComponent";
import store from "../../../store";
import siviModule from "../store";
import {mapGetters} from "vuex";

export default {
  name: "ProcessAFDPackageMessageComponent",
  props: {
    packageMessage: {
      type: Object,
      required: true
    },
    groupedPolicyMessages: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      foundCustomers: {},
      selectedCustomer: {},
      linkKey: 0,
    };
  },
  computed: {
    ...mapGetters("sivi", [
      "selectedCustomerId"
    ]),
    hasCustomer() {
      return this.selectedCustomerId !== false;
    }
  },
  created() {
    if (!store.hasModule("sivi")) {
      store.registerModule("sivi", siviModule);
    }
  },
  mounted() {
    store.dispatch("sivi/findCustomers", this.packageMessage.id);
  },
  components: {
    SiviMessageComponent,
    LinkAFDPackageMessagesToPoliciesComponent,
    SelectCustomerComponent,
    ShowAvailablePoliciesComponent,
    ShowCustomerComponent

  },
  methods: {
    rerenderLinkComponent() {
      this.linkKey += 1;
    }
  }
};
</script>

<style scoped>
table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>

<style>

.show-overflow.ant-collapse-item.ant-collapse-item-active > .ant-collapse-content {
  overflow: visible !important;
}
</style>